import 'jquery-toast-plugin/dist/jquery.toast.min.js';
import 'jquery-toast-plugin/dist/jquery.toast.min.css';

// ----- TOAST -----

export const toast = function (params) {  
  $.toast({
    // ------ GENERAL ------

    heading: params.title || null,
    text: params.content || null,
    showHideTransition: 'slide', // Transition: ['slide', 'fade', 'plain'].
    allowToastClose: params.allow_close || true,
    hideAfter: params.duration || 4000,
    stack: 5,
    // icon: ['success', 'error', 'warning', 'info'].

    // ------ POSITION ------

    // position: { top: 0, left: 0 }
    // position: ['bottom-left', 'bottom-right', 'top-left', 'top-right'].
    position: 'bottom-left',
    
    // ------ LOADER ------

    loader: false,

    // ------ STYLES ------
    
    // loaderBg: '#333',
    // bgColor: '#444',
    // textColor: '#eee',
    // textAlign: 'left',

    // ------ EVENTS ------

    // beforeShow: function () {},
    // afterShown: function () {},
    // beforeHide: function () {},
    // afterHidden: function () {}
  });
}


// WEBPACK FOOTER //
// ./src/scripts/toast.js